export const foodLogSourceTypes = [
  "planned_meal_occurrence",
  "planned_meal_event_assignment_v2",
] as const;
